import { createStyles, Theme } from '@material-ui/core/styles'

export default (theme: Theme) =>
	createStyles({
		container: {
			fontFamily: theme.typography.fontFamily,
			maxWidth: 670,
			margin: theme.spacing(1),
			paddingLeft: theme.spacing(2),
			paddingRight: theme.spacing(2),
			paddingTop: theme.spacing(2.5),
			paddingBottom: theme.spacing(2.5),
			backgroundImage: `linear-gradient(to right, ${theme.palette.primary.main}, ${theme.palette.secondary.main})`,
			borderRadius: theme.shape.borderRadius * 2,
			// [theme.breakpoints.up('xl')]: {
			// 	padding: theme.spacing(4),
			// },
		},
		bannerContainer: {
			'-webkit-box-shadow': '0px 1px 3px 0px rgba(180, 180, 180, 0.1)',
			'-moz-box-shadow': '0px 1px 3px 0px rgba(180, 180, 180, 0.1)',
			boxShadow: '0px 1px 3px 0px rgba(180, 180, 180, 0.1)',
		},
		headline: {
			minHeight: 44,
			maxWidth: 670,
			display: 'flex',
			flexDirection: 'row',
			justifyContent: 'space-between',
			alignContent: 'center',
			position: 'relative',
			paddingLeft: theme.spacing(1),
			paddingRight: theme.spacing(1),
			paddingTop: theme.spacing(1),
			paddingBottom: theme.spacing(1),
			color: theme.palette.grey[800],
			marginTop: theme.spacing(2),
			[theme.breakpoints.up('xl')]: {
				marginTop: theme.spacing(3),
			},
		},
		minWidth: {
			maxWidth: 670,
			width: '100%',
			[theme.breakpoints.up('sm')]: {
				minWidth: '100%',
				[theme.breakpoints.up('md')]: {
					minWidth: 670,
				},
			},
			// paddingRight: theme.spacing(1),
		},
		contentContainer: {
			display: 'flex',
			flexDirection: 'column',
		},
		fontSize24: {
			fontFamily: 'Open Sans, sans-serif',
			fontSize: 16,
			lineHeight: '28px',
			[theme.breakpoints.up('sm')]: {
				fontSize: 20,
				lineHeight: '28px',
				[theme.breakpoints.up('md')]: {
					fontSize: 28,
					lineHeight: '36px',
					// [theme.breakpoints.up('lg')]: {
					// 	fontSize: 40,
					// 	lineHeight: '43px',
					// 	[theme.breakpoints.up('xl')]: {
					// 		fontSize: 48,
					// 		lineHeight: '52px',
					// 	},
					// },
				},
			},
		},
		headlineThin: {
			fontWeight: 100,
			marginRight: theme.spacing(1),
		},
		headlineThick: {
			fontWeight: 500,
		},
		h5: {
			color: theme.palette.common.white,
			fontWeight: 'bold',
		},
		h6: {
			color: theme.palette.common.white,
			fontWeight: 300,
		},
		tagline: {
			maxWidth: 670,
			paddingLeft: theme.spacing(1),
			paddingRight: theme.spacing(1),
			fontWeight: 300,
			color: theme.palette.grey[600],
			fontSize: 12,
			lineHeight: '18px',
			marginBottom: theme.spacing(2),
			[theme.breakpoints.up('sm')]: {
				fontSize: 16,
				lineHeight: '22px',
				[theme.breakpoints.up('md')]: {
					fontSize: 20,
					lineHeight: '32px',
				},
			},
		},
		exploreTeams: {
			marginTop: theme.spacing(1),
			borderColor: theme.palette.common.white,
			color: theme.palette.common.white,
			height: 28,
			borderRadius: 14,
			padding: theme.spacing(1),
			'& span': {
				fontWeight: 600,
				fontSize: 14,
				// lineHeight: '28px',
			},
			[theme.breakpoints.up('sm')]: {
				height: 36,
				borderRadius: 18,
				'& span': {
					fontSize: 16,
				},
			},
			[theme.breakpoints.up('md')]: {
				height: 36,
				borderRadius: 18,
				'& span': {
					fontSize: 16,
				},
			},
			[theme.breakpoints.up('lg')]: {
				height: 36,
				borderRadius: 18,
				'& span': {
					fontSize: 16,
				},
			},
			[theme.breakpoints.up('xl')]: {
				height: 36,
				borderRadius: 18,
				'& span': {
					fontSize: 16,
				},
			},
		},
		fontSize12: {
			fontFamily: 'Open Sans, sans-serif',
			fontSize: 12,
			lineHeight: '18px',
			[theme.breakpoints.up('sm')]: {
				fontSize: 16,
				lineHeight: '24px',
				[theme.breakpoints.up('md')]: {
					fontSize: 18,
					lineHeight: '30px',
					[theme.breakpoints.up('lg')]: {
						fontSize: 18,
						lineHeight: '30px',
						[theme.breakpoints.up('xl')]: {
							fontSize: 20,
							lineHeight: '30px',
						},
					},
				},
			},
		},
		label: {
			paddingTop: 0,
			paddingBottom: 0,
			[theme.breakpoints.up('md')]: {
				paddingTop: theme.spacing(1),
				paddingBottom: theme.spacing(1),
			},
		},
		ellipsis: {
			flexWrap: 'nowrap',
			textOverflow: 'ellipsis',
			whiteSpace: 'nowrap',
			overflow: 'hidden',
			width: '100%',
		},
		flexGrow: {
			flexGrow: 1,
			// backgroundColor: '#fafafa',
		},
		paddingBottom: {
			paddingBottom: theme.spacing(1),
		},
		paddingTop: {
			paddingTop: theme.spacing(8),
		},
		createButton: {
			boxShadow:
				'0px 3px 5px -1px rgba(0,0,0,0.1), 0px 6px 10px 0px rgba(0,0,0,0.1), 0px 1px 18px 0px rgba(0,0,0,0.1)',
			textTransform: 'capitalize',
			top: 0,
			// right: theme.spacing(1),
			background: theme.palette.action.active,
			fontWeight: 600,
			[theme.breakpoints.down('xs')]: {
				zIndex: 999,
				position: 'fixed',
				top: 'auto',
				bottom: theme.spacing(1),
				right: theme.spacing(1),
				padding: '0 8px!important',
			},
		},
		createButtonIcon: {
			marginRight: 0,
			[theme.breakpoints.up('sm')]: {
				marginRight: theme.spacing(1),
			},
		},
	})
